// import Vue from 'vue'
import axios from 'axios/index'

const state = {
  payLoading: false,
  badgeOrderDetails: {},
  clientToken: 0,
  transactionId: 0,
  transactionSuccessful: false,
  transactionSuccessfulLicense: false
}

const getters = {
  getPayLoading (state) {
    return state.payLoading
  },
  getBadgeOrderDetails (state) {
    return state.badgeOrderDetails
  },
  getClientToken (state) {
    return state.clientToken
  },
  getTransactionId (state) {
    return state.transactionId
  },
  getTransactionSuccessful (state) {
    return state.transactionSuccessful
  },
  getTransactionSuccessfulLicense (state) {
    return state.transactionSuccessfulLicense
  }
}

const actions = {

  purchaseLicense ({dispatch, state, commit, rootGetters}, userId) {
    dispatch('fetchBraintreeTokenForUpgrade', userId).then(response => {
      commit('setClientToken', response.data.clientToken)
      // commit('setPayLoading', false)
    })
  },

  fetchBraintreeTokenForUpgrade ({dispatch, state, commit, rootGetters}, userId) {
    return axios({
      url: process.env.API_URL + `/ws/checkout/client-token/user/${userId}/course/${process.env.GAME_ID}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },

  fetchBraintreeToken ({dispatch, state, commit, rootGetters}) {
    return axios({
      url: process.env.API_URL + `/ws/checkout/client-token`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },

  createBadgeOrder ({dispatch, state, commit, rootGetters}, data) {
    commit('setPayLoading', true)
    axios({
      url: process.env.API_URL + `/ws/checkout/order/badge`,
      method: 'POST',
      data,
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      commit('setBadgeOrderDetails', response.data)
      dispatch('fetchBraintreeToken').then(response => {
        commit('setClientToken', response.data.clientToken)
        commit('setPayLoading', false)
      })
    })
  }
}
const mutations = {
  setPayLoading (state, flag) {
    state.payLoading = flag
  },
  setBadgeOrderDetails (state, data) {
    state.badgeOrderDetails = data
  },
  setClientToken (state, token) {
    state.clientToken = token
  },
  setTransactionId (state, id) {
    state.transactionId = id
  },
  setTransactionSuccessful (state, status) {
    state.transactionSuccessful = status
  },
  setTransactionSuccessfulLicense (state, status) {
    state.transactionSuccessfulLicense = status
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/braintree.js